module.exports = __webpack_public_path__ + "static/img/login.c791c42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login.jpg
// module id = C5b7
// module chunks = 1